import React, { useEffect, useRef, useState } from "react";
import { FilterWrapper } from "../../../assets/styles/FilterStyle.js";
import { TableWrapper } from "../../../Components/styledConstant.js";
import { AddNewCity, getCityList, getSuggestList, UpdateCityStatus } from "../../../utils/api.js";
import debounce from "lodash.debounce";
import AutoSuggestion from "../../../Components/AutoSuggest/AutoSuggest.js";
import { isEmpty } from "../../../utils/common.js";
import Pagination from "../../../Components/Pagination/Pagination.jsx";
import { useNavigate, useRouteError } from "react-router-dom";
import { ModalPopUp } from "../../../Components/ModalPopUp/ModalPopUp.jsx";
import Input from "../../../Components/Input/Input.jsx";
import { useDebounce } from "../../../Components/hooks/useDebounce.js";


const hotelfilterData = {
 searchId:null,
 countryCode:null



}


const CityList = () => {
  const autoSuggestionRef = useRef(null);
    const [cityList,setCityList] = useState([]); 
    const [cityData,setCityData] =  useState(hotelfilterData);
    const [totalPages, setTotalPages] = useState(null);
    const [totalElements, setTotalElements] = useState("");
    const [currPage, setCurrPage] = useState(0);
    const [pageSize, setPageSize] = useState(15);
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [showCity,setShowCity] = useState(false);
    const [images, setImages] = useState([]);
    const [message, setMessage] = useState("");
    const [newCityData, setNewCityData] = useState({
      cityName:null,
      active:null,
      cityCode:null,
      countryCode:null,
      feedSource:null
  });
    
   const navigate = useNavigate();
   const [errors, setErrors] = useState({});
   const [loading,setLoading] = useState(false);



   const validateForm = () => {
    const newErrors = {};
  
    if (!newCityData.cityName || newCityData.cityName.trim() === "") {
      newErrors.cityName = "City Name is required.";
    }
    if (!newCityData.active) {
      newErrors.active = "Status is required.";
    }
    if (!newCityData.cityCode || newCityData.cityCode.trim() === "") {
      newErrors.cityCode = "City Code is required.";
    }
    if (!newCityData.countryCode || newCityData.countryCode.trim() === "") {
      newErrors.countryCode = "Country Code is required.";
    }
    if (!newCityData.feedSource || newCityData.feedSource.trim() === "") {
      newErrors.feedSource = "Feed Source is required.";
    }
    if (images.length === 0) {
      newErrors.files = "At least one file is required.";
    } 
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if no errors
  };

  console.log("erross",errors);

    const handleViewCity = (cityId) => {
      navigate(`/hotel/view/cities/${cityId}`); // Navigate to the city details page
    };
    const handleModalInputChange = (e) => {
      const { name, value } = e.target;
      setNewCityData((prev) => ({
          ...prev,
          [name]: value,
      }));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        autoSuggestionRef.current &&
        !autoSuggestionRef.current.contains(event.target)
      ) {
        setShowSuggestions(false); // Close the popup
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
    
    const fetchSuggestions = (query, identifier,type) => {
      getSuggestList(query, identifier,type)
        .then((resp) => {
          console.log("API Response:", resp?.data.data.suggestions); // Debug response
          if (resp?.data.data.suggestions) {
            setSuggestions([...resp?.data.data.suggestions]);
            setShowSuggestions(true);
           
          } else {
            setSuggestions([]);
            setShowSuggestions(false); // Handle no suggestions case
            
          }
        })
        .catch((error) => console.error("Error fetching suggestions:", error));
    };
    
const debounceValue = useDebounce(cityData?.cityName, 500);
   
    const handleDetailData = (e) => {
      const { name, value } = e.target;
      setCityData((prev) => ({
          ...prev,
          [name]: value ? value:null,
      }));
      if (name === "cityName" && value.trim()) {
      //  fetchSuggestions(value, "loc","1"); // Fetch suggestions only when there's a value
      } else{
        setSuggestions([]);
        setShowSuggestions(false);

      }
  
    };
  
     useEffect(() =>{
      fetchSuggestions(debounceValue, "loc","1");
       },[debounceValue])
   
   
    const showCityList = (page,key = "")=>{
        console.log("setDetailData",cityData)
       
        let param = {
            page:page,
            searchId:cityData?.searchId,
            countryCode:cityData?.countryCode,
           // active:hoteldata?.active
           
        }
        if(key === "refresh"){
       setCityData(hotelfilterData);
         param = hotelfilterData;
      }
         setLoading(true);
        getCityList(param).then((resp)=>{
          console.log("response city",resp);
                setLoading(false);
                if(resp){
                    
                    setCityList(resp?.data?.data?.city?.content);
                    setTotalPages(resp?.data?.data?.city?.totalPages)
                
                }
            
        
        
            })
        }
        const currPageSet = (currentPage) =>{
           
            showCityList(currentPage)
        setCurrPage(currentPage);
        }

        useEffect(()=>{
            showCityList(currPage);
            },[])
            
  const handleAddCity = ()=>{
    setShowCity((prev)=>prev ? false:true);
      }
  const handleSubmit =()=>{

    if (!validateForm()) {
      return; 
    }


    const formData = new FormData();
    
    // Append each file to the FormData object under the "files" key
    images.forEach((image) => {
      formData.append("files", image.file); // Use the "files" key for multiple files
    });

    
    const request = {
      cityName:newCityData?.cityName,
      active:newCityData?.active === "true"?true:false,
      cityCode:newCityData?.cityCode,
      countryCode:newCityData?.countryCode,
      feedSource:newCityData?.feedSource // Add any other relevant fields if needed
    };
  
    // Append the "request" object as JSON to FormData
    formData.append("request", JSON.stringify(request));
    
    AddNewCity(formData).then((resp)=>{
     console.log("res",resp)

    })

    }
    const handleFileChange = (event) => {
      const files = Array.from(event.target.files);
      const newImages = files.map((file) => ({
        id: Date.now() + Math.random(),
        file,
        url: URL.createObjectURL(file),
      }));
      setImages((prev) => [...prev, ...newImages]);
      setMessage("Images uploaded successfully!");
      setTimeout(() => setMessage(""), 3000);
    };
    const handleDrop = (event) => {
      event.preventDefault();
      const files = Array.from(event.dataTransfer.files);
      const newImages = files.map((file) => ({
        id: Date.now() + Math.random(),
        file,
        url: URL.createObjectURL(file),
      }));
      setImages((prev) => [...prev, ...newImages]);
    };
    const preventDefault = (e) => e.preventDefault();

    const updateStatus =(id,status)=>{
     UpdateCityStatus(id).then((res)=>{
    if(res){
      showCityList(currPage);
    }

      })

    }

    return(
        <>
         <div className="userlisthead_container">
         <div style={{ padding: "30px" }}>
         <div className="transaction_main_container">
         <div className="userlist_head mb-5">
            <div className="userlist_heading">
              <div className="userlist_left">
                <label>City List</label>
              </div>

             
           <div>
            <button onClick={() => navigate("/hotel/addCity")} className="userlist_btn">Add New City</button>
            
           </div>
            </div>
          </div>
        <FilterWrapper>
          <div className="filterBox">
              <div style={{width:"100%"}}>
                <div className="flex align-items gap-20">
                
                  <div style={{position:"relative"}}>
                    <input
                      type="text"
                      name="cityName"
                      placeholder="City Name"
                     value={cityData?.cityName || ""}
                      onChange={handleDetailData}
                    
                     // onKeyDown={handleKeyDown}
                    />

{ showSuggestions && suggestions.length > 0 && (
     <div ref={autoSuggestionRef}>
<AutoSuggestion
    fromCityList={suggestions}
    setCityName={(name) =>
      setCityData((prev) => ({
        ...prev,
        cityName: name,
      }))
    }
    setCityId={(id) =>
      setCityData((prev) => ({
        ...prev,
        searchId: id, // Set the selected city ID
      }))
    }
   
    setShowCity={setShowSuggestions}
    showCity={{ fromCityShow: true }}
    cityNameKey="cityName"
    inputElement={null}
  />

     </div>
)}

                  </div>
                 
                  <div>
                    <input
                      type="text"
                      name="countryCode"
                      placeholder="Country Code"
                      value={cityData.countryCode || ""}
                     onChange={handleDetailData}
                     
                     // onKeyDown={handleKeyDown}
                    />
                  </div>
                
                 
                 
                  <div className="button">
                    <button
                      className="userlist_btn"
                     onClick={(e) => showCityList(0, "search")}
                    >
                      Search
                    </button>
                  </div>

                  <div className="button">
                    <button
                      className="refresh-btn"
                     onClick={(e) => showCityList(e, "refresh")}
                    >
                      <i className="fa fa-refresh"></i>
                    </button>
                  </div>
                </div>
              </div>
             
            </div>



              </FilterWrapper>
     
          </div>

          <div className="table-loader">
            {/* {loading && <LocalLoader className="tableLoader" />} */}
            <TableWrapper className="table-card-wrapper">
              <table className="table">
                <thead>
                  <tr>
                   
                    <th>City Name </th>
                    <th>State</th>
                    <th>conutry code</th>
                    
                    <th>Last Update</th>
                    <th>status</th>
                    <th>Action</th>
                   
                   
                  </tr>
                </thead>
                <tbody>
                {cityList && 
                    cityList?.map((items)=>{

                          // const dateTimeString = items?.lastUpdatedAt;
                          //  let [date, time] = dateTimeString.split("T");
                          //  let newTime = time.slice(0, 8);
                        return(
                         <>
                            <tr>
                           
                            <td>{items?.name}</td>
                            <td>{items?.state == null ?"-":items?.state }</td>
                            <td>{items?.countryCode}</td>
                            <td>{items?.lastUpdatedAt ?? "-"}</td>
                            <td>
                            <div
                                    className={`custom-toggle toggle_button ${
                                      items.active === true ? "active" : ""
                                    }`}
                                    onClick={() =>
                                      updateStatus(items.id, items.active)
                                    }
                                    styled={{
                                      margin: "0",
                                      marginRight: "12px",
                                    }}
                                  >
                                    <div className="slider"></div>
                                  </div>
                            </td>
                            <td className="user_action_btn button">
                  <span>
                    <button onClick={() => handleViewCity(items?.id)}>
                    <i class="fa-solid fa-pen-to-square update" aria-hidden="true"></i>

                    </button>
                  </span>
                            </td>
                           
                             </tr>
                         </>


                        )
                      

                    })}

                </tbody>
              </table>
            </TableWrapper>
          </div>
            
          {totalPages > 1 && (
        <Pagination
         items={showCityList}
          itemsPerPage={pageSize}
          setitemsPerPage={setPageSize}
          currentPage={currPage}
          setcurrentPage={(page)=>currPageSet(page)}
          totalPages={totalPages}
          forcePage={currPage}
        />
      )}
            
            
            </div>
        
        
        
        <></>
         </div>
        {showCity && <ModalPopUp>
         <div className="subadmin_container justify-between flex column gap-20" style={{width:"50%"}}>
         <div style={{padding:"30px",flex:"1 1 100%"}}>
            <p>Add New City</p>
       <div className="flex gap-10">

          <div style={{flex:"1 1 50%"}}>
                <div className="labelname">
                  <label>City Name</label>
                
                </div >
                <Input
                  type="text"
                 
                placeholder="City Name"
                  name="cityName"
                  value={newCityData?.cityName}
                  onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.cityName && (
                  <p className="error fs-12 mt-10">{errors.cityName}</p>
                )}
              </div>

              <div className="input-field"  style={{flex:"1 1 50%"}}>
              <div className="labelname">
                  <label>Status</label>
                
                </div>
                    <select
                    style={{width:"100%", maxWidth:"330px"}}
                      className="input_select_field"
                      name="active"
                      value={newCityData?.active}
                      onChange={handleModalInputChange}
                    >
                      {/* <option value={""}>User Type</option> */}
                   
                      <option value="">status</option> 
                     <>
                      <option value={"true"}>ACTIVE</option>
                     <option value={"false"}>INACTIVE</option>
                      </>
                    </select>
                    {errors.active && (
                  <p className="error fs-12 mt-10">{errors.active}</p>
                )}
                  </div>
          </div>

          <div className="flex gap-10 mt-20">
          <div  style={{flex:"1 1 50%"}}>
                <div className="labelname">
                  <label>City Code</label>
                
                </div>
                <Input
                  type="text"
               
                  placeholder="City Code"
                  name="cityCode"
                  value={newCityData?.cityCode}
                  onChange={handleModalInputChange}
                  
                />
                {errors.cityCode && (
                  <p className="error fs-12 mt-10">{errors.cityCode}</p>
                )}
              </div>

              <div  style={{flex:"1 1 50%"}}>
                <div className="labelname">
                  <label>Country Code</label>
                
                </div>
                <Input
                  type="text"
                  
                  placeholder="Country Code"
                  name="countryCode"
                  value={newCityData?.countryCode}
                  onChange={handleModalInputChange}
              
                />
                {errors.countryCode && (
                  <p className="error fs-12 mt-10">{errors.countryCode}</p>
                )}
              </div>
          </div>

          <div className="flex gap-10 mt-20">
          <div  style={{flex:"1 1 50%"}}>
                <div className="labelname">
                  <label>Feed Source</label>
                
                </div>
                <Input
                  type="text"
                  maxLength={10}
                  placeholder="Feed Source"
                  name="feedSource"
                  value={newCityData?.feedSource}
                  onChange={handleModalInputChange}

               
                />
                {errors.feedSource && (
                  <p className="error fs-12 mt-10">{errors.feedSource}</p>
                )}
              </div>

             
             <div style={{flex:"1 1 50%"}}>
             <div className="labelname">
                  <label>Upload File</label>
                
                </div>
                <div
               style={{flex:"1 1 50%"}}
        className=""
        onDrop={handleDrop}
        onDragOver={preventDefault}
        onDragEnter={preventDefault}
        onDragLeave={preventDefault}
      >

        <input
          type="file"
          multiple
          accept=".jpg, .jpeg, .png, .webp, .avi"
          id="fileUpload"
          
          onChange={handleFileChange}
        />
       
              </div>
              {errors.files && <p className="error fs-12 mt-10">{errors.files}</p>}
          
             
             </div>
             
             
          
          
          </div>
      
     {message&& <p className="success-message">{message}</p>}

         </div>
       
         <div className="flex gap-10" style={{padding:"30px"}}>
        
         <div>
          <button onClick={handleAddCity} className="userlist_btn">Cancle</button>
        </div>
        <div>
          <button onClick={handleSubmit} className="userlist_btn">Submit</button>
        </div>
         </div>
         </div>

         </ModalPopUp>}
        
        
        </>
    )

}

export default CityList;